module.exports = __webpack_public_path__ + "images/graphic-header_24804d4195073d20270362c478b4de57.png";